import apiCentralSeguranca from '@/api/centralseguranca';

export default {

  state : {   
    user: localStorage.getItem(process.env.VUE_APP_CLIENT_ID) || '',
    status: '',
    cidadao : ''
  },

  mutations : {
    authRequest(state) {
      state.status = 'loading';
    },
    authSuccess(state, payload) {
      state.status = 'success';
      state.user = payload;
    },
    authError(state) {
      state.status = 'error';
    },
    authLogout(state) {
      state.status = '';
      state.user = '';
    },
    limparUserState(state){
      state.user = '';
      localStorage.removeItem(process.env.VUE_APP_CLIENT_ID);
      
    },
    setCidadao(state,cidadao){
      state.cidadao = cidadao;
    },
    limparCidadao(state){
      state.cidadao = '';
    }
  },

  getters : {
    isAuthenticated(state) { 
      if(state.user == '') {
        return false;    
      } 
      if(JSON.parse(state.user).access_token) {
        return true;
      }
    },
    authStatus(state) {
      return state.status;
    },
    getUser(state) {
      return state.user;
    },
    getCidadao(state) {
      return state.cidadao;
    }
  },

  actions : {
    async authFilter({commit})  {
      return new Promise((resolve, reject) => {
        commit('authRequest');

        let accessToken = null;
        const userKey = process.env.VUE_APP_CLIENT_ID;      
        const user = localStorage.getItem(userKey);
        const userData = JSON.parse(user);
        
		if(user && userData && userData.access_token){
          accessToken = userData.access_token;
		  
        } else {
          accessToken = apiCentralSeguranca.getHashValue('access_token');
        }
      
        if(accessToken != null && (userData == null || userData.exp > Math.floor(new Date().getTime()/1000.0))) {
            var base64Url = accessToken.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = JSON.parse(decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join('')));

            jsonPayload.access_token = accessToken;
			
			let dados = JSON.stringify(jsonPayload);

            localStorage.setItem(userKey, dados);
            commit('authSuccess', dados);
            resolve(true);
            
        } else {
            localStorage.removeItem("user");
            localStorage.removeItem(process.env.VUE_APP_CLIENT_ID);
            reject(false);
            window.location.href = '' + apiCentralSeguranca.authorizeUrl;
        }

      })
    },
    authLogout({commit}) {
      return new Promise((resolve) => {
        commit('authLogout');
        localStorage.removeItem("user");
        localStorage.removeItem(process.env.VUE_APP_CLIENT_ID);
        window.getApp.$router.push('/');
        resolve();
      })
    },
    obterCidadao({commit,getters}){
      if (getters.getCidadao == '') {
        let dados = '';
        apiCentralSeguranca.getInformacoesCidadao((JSON.parse(getters.getUser).access_token))
        .then(res => {
          dados = res.data;
          commit('setCidadao', dados);
        }).catch( () => {
          //reject(false);
        });
        return dados;
      } else{
        return getters.getCidadao;
      }
    }
  }
}